import * as React from 'react';
import { usePageTitle } from '~components/DashboardWrapper/PageTitle';
import { t } from '~/i18n';
import { Panel } from '@ixicare/ui';
import HealthcareProviderFormContainer from '~/containers/HealthcareProviders/HealthcareProviderForm';

const HealthcareProviderCreatePage = () => {
  usePageTitle(t('healthcareProviders.create.title'));
  return (
    <Panel>
      <HealthcareProviderFormContainer />
    </Panel>
  );
};

export default HealthcareProviderCreatePage;
